var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    "aria-label": "Pinterest icon"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "var(--color-secondary-dark)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.34 16.238c0 2.157-.757 4.134-2.134 5.564-1.291 1.343-3.045 2.114-4.812 2.114-1.412 0-2.448-.382-3.19-.851l-.861 3.661a1.097 1.097 0 11-2.136-.502l2.925-12.432a1.097 1.097 0 112.136.503l-1.504 6.392c.319.382 1.09 1.035 2.63 1.035 2.336 0 4.753-2.052 4.753-5.484a6.216 6.216 0 10-11.6 3.107 1.097 1.097 0 01-1.899 1.097 8.41 8.41 0 1115.693-4.204z",
    fill: "#fff"
  })));
}
export default SvgPinterest;